import React, { useRef } from 'react';
import DateTime from 'react-datetime';
import { Calendar } from 'jbc-front/components/icons';
import { Label } from 'src/components/Form';
import styles from 'jbc-front/components/Form.scss';
import moment from 'moment';

import * as validators from 'src/jbc-front/utils/validators';

export const CustomYearPicker = (props) => {
  const dateTimeRef = useRef(null);

  const yearFieldProps = {
    viewMode: 'years',
    dateFormat: 'YYYY',
    normalize: (value) => (isObject(value) && value.format ? value.format('YYYY') : value || ''),
    format: (value) => (isString(value) ? value.replace(/^(\d{4})-(\d{2})-(\d{2}).*$/, '$1') : value || ''),
    validate: validators.year,
  };

  const { label, changed, value, name, onChange, placeholder, ...rest } = props;

  return (
    <div>
      <Label text={label} changed={changed} />
      <div className={`${styles.icnTextarea} ${styles.boxWrap}`}>
        <DateTime
          locale="en"
          value={value.toString()}
          onChange={(e) => {
            const changedYear = moment(e).year();
            // detect if year is valid, then change the value
            if (isValidYear(changedYear)) {
              onChange(e);
            }
          }}
          inputProps={{ disabled: true, style: { border: '1px solid #ccc', background: '#fff' }, placeholder }}
          closeOnSelect={true}
          timeFormat={false}
          {...rest}
          {...yearFieldProps}
          ref={dateTimeRef}
        />
        <i onClick={() => dateTimeRef.current && dateTimeRef.current.openCalendar()}>
          <Calendar />
        </i>
      </div>
      {/* <Error meta={meta} label={label} /> */}
    </div>
  );
};

const isValidYear = (year) => {
  // Check if the year is within a valid range
  return year >= 1900 && year <= 2100;
};
